import { apply, put, select } from 'redux-saga/effects';
import {
  loadMoreSocialWallPostsFailedAction,
  loadMoreSocialWallPostsSuccessAction,
  loadSocialWallPostsSuccessAction,
  loadSocialWallPostsFailedAction,
  loadSocialWallPostFailedAction,
  loadSocialWallPostSuccessAction,
  createSocialWallPostSuccessAction,
  createResponseSuccessAction,
  reloadSocialWallPostsSuccessAction,
  loadSocialWallPostsAction,
  deleteSocialWallPostSuccessAction,
} from '../reducers/socialwall.reducers';

import { errorNotification, successNotification } from '../reducers/notification.reducers';

export function* loadSocialWallPosts(socialWallApi, { payload }) {
  const { skip, take, filterType, filterId, isReloadResquest } = payload;

  try {
    const response = yield apply(
            socialWallApi,
            socialWallApi.loadSocialWallPosts, [skip, take, filterType, filterId],
        );

    if (response.errorCode) {
    } else if (isReloadResquest) {
      yield put(loadMoreSocialWallPostsSuccessAction(response));
    } else {
      yield put(loadSocialWallPostsSuccessAction(response));
    }
  } catch (e) {
    console.log(e);
  }
}

export function* createSocialWallPost(socialWallApi, { payload }) {
  try {
    const response = yield apply(
            socialWallApi,
            socialWallApi.createSocialWallPost, [payload],
        );

    if (response.errorCode) {

    } else {
      yield put(createSocialWallPostSuccessAction(response));
    }
  } catch (e) {

  }
}

export function* createSocialWallResponse(socialWallApi, { payload }) {
  try {
    const { id, dto } = payload;

    const response = yield apply(
            socialWallApi,
            socialWallApi.createSocialWallResponse, [id, dto],
        );

    if (response.errorCode) {
    } else {
      yield put(createResponseSuccessAction({ id, response }));
    }
  } catch (e) {
  }
}

export function* loadSocialPost(socialWallApi, { payload }) {
  try {
    const response = yield apply(
            socialWallApi,
            socialWallApi.loadSocialWallPost, [payload],
        );

    if (response.errorCode) {
      yield put(errorNotification('Du darfst diesen Inhalt leider nicht aufrufen'));
    } else {
      yield put(loadSocialWallPostSuccessAction(response));
    }
  } catch (e) {

  }
}

export function* updateSocialWallPost(socialWallApi, { payload }) {
  const { id, dto } = payload;

  try {
    const response = yield apply(
      socialWallApi,
      socialWallApi.updatePost, [id, dto],
    );

    if (response.errorCode) {
        // do something
    } else {
      yield put(loadSocialWallPostsAction({ skip: 0, take: 5 }));
    }
  } catch (e) {
  }
}

export function* removeImageForSocialPost(socialWallApi, { payload }) {
  try {
    const response = yield apply(
            socialWallApi,
            socialWallApi.deleteFile, [payload],
        );

    if (response.errorCode) {
            // error
    } else {
      yield put(deleteSocialWallPostSuccessAction(payload));
    }
  } catch (e) {

  }
}

export function* removeSocialWallPost(socialWallApi, { payload }) {
  try {
    const response = yield apply(
      socialWallApi,
      socialWallApi.deletePost, [payload],
    );

    if (response.errorCode) {
    }
  } catch (e) {
  }
}




// WEBPACK FOOTER //
// ./src/app/sagas/socialwall.sagas.js